/**
 * AlmadarPostWelcomeToAlmadarARPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostWelcomeToAlmadarARPostPage
 */

import { useAlmadarPostWelcomeToAlmadarARPostPageLogic } from '@/hooks/traits/useAlmadarPostWelcomeToAlmadarARPostPageLogic';
import type { AlmadarPostWelcomeToAlmadarARPostPageConfig } from '@/hooks/traits/useAlmadarPostWelcomeToAlmadarARPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostWelcomeToAlmadarARPostView as AlmadarPostWelcomeToAlmadarARPostViewEntity } from '@app/shared';
import { AlmadarPostWelcomeToAlmadarARPostView } from '@/components/traits/AlmadarPostWelcomeToAlmadarARPostView';
import { Box } from '@almadar/ui/components';
import { AlmadarPostWelcomeToAlmadarARPostFooterView } from '@/components/traits/AlmadarPostWelcomeToAlmadarARPostFooterView';
import { Stack } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { AlmadarPostWelcomeToAlmadarARPostHeaderView } from '@/components/traits/AlmadarPostWelcomeToAlmadarARPostHeaderView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostWelcomeToAlmadarARPostPageViewProps {
  config?: Partial<AlmadarPostWelcomeToAlmadarARPostPageConfig>;
}

export function AlmadarPostWelcomeToAlmadarARPostPageView({ config: propsConfig }: AlmadarPostWelcomeToAlmadarARPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostWelcomeToAlmadarARPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostWelcomeToAlmadarARPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostWelcomeToAlmadarAR" trait="AlmadarPostWelcomeToAlmadarARPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostWelcomeToAlmadarARPostPage">{slotWriter['main'] === 'INIT' ? (<Stack gap="none" direction="vertical"><AlmadarPostWelcomeToAlmadarARPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box fullWidth={true} bg="transparent" paddingY="xl"><Container size="xl" padding="lg" maxWidth="xl"><AlmadarPostWelcomeToAlmadarARPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostWelcomeToAlmadarARPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostWelcomeToAlmadarARPostPageView;
